module.exports = __webpack_public_path__ + "assets/img/4651-mu.svg";